import { ArtifactRequest } from '@cotera/client/app/etc/api/typed-client';
import { Text } from '@cotera/client/app/components';
import { Button, Loading } from '@cotera/client/app/components/ui';
import {
  useArtifactRequests,
  useInvalidateArtifactById,
} from '@cotera/client/app/hooks/artifacts';
import { sortBy } from 'lodash';
import { Link } from 'react-router-dom';
import { Card } from '@cotera/client/app/components/headless';
import { LegacyLayout } from '@cotera/client/app/layout';

export const Artifacts = () => {
  const reqs = useArtifactRequests({ page: 1 });

  return (
    <LegacyLayout>
      <div className="w-full p-4 flex flex-col">
        <Card.Container>
          <Card.Header>
            <Card.Title>Artifact Cache </Card.Title>
            <Text.Caption className="text-sm mt-2 space-y-4">
              <div>
                Recently run warehouse queries that the system can use to serve
                related queries without returning to the warehouse
              </div>
              {reqs.isFetching ? (
                <Loading.Spinner />
              ) : (
                <Button text="Refresh" onClick={() => reqs.refetch()} />
              )}
            </Text.Caption>
          </Card.Header>
          <Card.Content>
            {reqs.data ? <ListArtifacts reqs={reqs.data} /> : <Loading.Dots />}
          </Card.Content>
        </Card.Container>
      </div>
    </LegacyLayout>
  );
};
const ListArtifacts: React.FC<{ reqs: ArtifactRequest[] }> = ({ reqs }) => {
  const mapped = sortBy(
    reqs.map((req) => {
      const status =
        req.fullfillment !== null
          ? 'Fullfilled'
          : req.failure !== null
          ? 'Failed'
          : 'Pending';

      return {
        id: req.id,
        Hash: req.sqlHash,
        'Requested At': new Date(req.createdAt),
        Status: status,
        'Invalidated At':
          req.invalidatedAt !== null ? new Date(req.invalidatedAt) : null,
      };
    }),
    (x) => x['Requested At']
  ).reverse();

  return (
    <>
      <table className="w-full">
        <thead>
          <tr>
            <th>
              <Text.Caption>Id</Text.Caption>
            </th>
            <th>
              <Text.Caption>Hash</Text.Caption>
            </th>
            <th>
              <Text.Caption>Requested At</Text.Caption>
            </th>
            <th>
              <Text.Caption>Status</Text.Caption>
            </th>
            <th>
              <Text.Caption>Invalidated At</Text.Caption>
            </th>
          </tr>
        </thead>
        <tbody>
          {mapped.map((row) => (
            <tr key={row.id}>
              <td>
                <Link
                  to={`/artifacts/${row.id}`}
                  className="text-indigo-700 hover:text-indigo-900"
                >
                  {row.id}
                </Link>
              </td>
              <td>{row.Hash}</td>
              <td>{new Date(row['Requested At']).toISOString()}</td>
              <td>{row.Status}</td>
              <td>
                {row['Invalidated At'] !== null ? (
                  new Date(row['Invalidated At']).toISOString()
                ) : (
                  <InvalidateCell reqId={row.id} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const InvalidateCell: React.FC<{ reqId: string }> = ({ reqId }) => {
  const invalidate = useInvalidateArtifactById();
  if (invalidate.isPending) {
    return <Loading.Spinner />;
  }
  return (
    <Button
      text={'Invalidate'}
      theme="error"
      onClick={() => invalidate.mutate({ id: reqId })}
    />
  );
};
